import React from "react";
import g from "glamorous";
import { css } from "glamor";
import Img from "gatsby-image";
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/fontawesome-free-brands';
import { faTwitter } from '@fortawesome/fontawesome-free-brands';
import { faLinkedin } from '@fortawesome/fontawesome-free-brands';

const PostTitle = g.h1({
  color: 'rgba(0,0,0,0.3) !important',
  letterSpacing: '-0.02em',
  fontWeight: 700,
  fontStyle: 'normal',
  marginBottom: '15px',
  fontFamily: 'sans-serif',
})

const PostContent = g.article({
  display: 'block',
  margin: '2px 0 0',
  fontSize: '18px',
  lineHeight: '1.58',
  letterSpacing: '-0.003em',
  fontFamily: '"PT Serif"',
  fontStyle: 'normal',
  fontWeight: 400,
})

const ImageDiv = g.div({
  padding: '15px 0 !important',
  margin: '20px 0 !important',
})

export default ({ data }) => (
  <g.Div>
    <g.Div>
      <PostTitle>Bio</PostTitle>
      <PostContent>
        <p>Wayne WEN is a programmer. Currently, he is a Senior Software Engineer working at LinkedIn. Prior to it, he worked on Samsung Pay team at Samsung Research America.</p>
      </PostContent>
    </g.Div>
    <ImageDiv>
      <Img sizes={ data.imageSharp.sizes } css={{ borderRadius: '2px'}}/>
    </ImageDiv>
  </g.Div>
);

export const query = graphql`
  query FrontPageQuery {
    imageSharp(id: { regex: "/about_selfie/" }) {
      sizes(maxWidth: 700) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/bio.js